export default __webpack_public_path__ + "static/media/weather-dashboard.bb18d22c.PNG";